import { render, staticRenderFns } from "./AgentEdit.vue?vue&type=template&id=513ea3b0&"
import script from "./AgentEdit.vue?vue&type=script&lang=ts&"
export * from "./AgentEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports